// extracted by mini-css-extract-plugin
export var active = "_39-9";
export var backButton = "_39-8";
export var clone = "_39-e";
export var collapseBar = "_39-j";
export var collapseMode = "_39-l";
export var collapsed = "_39-n";
export var dragHandle = "_39-c";
export var dropdownIcon = "_39-g";
export var expanding = "_39-m";
export var hidden = "_39-w";
export var iconContainer = "_39-p";
export var iconSwapper = "_39-v";
export var navItem = "_39-6";
export var navItemIcon = "_39-f";
export var navProfile = "_39-7";
export var notificationCountBadge = "_39-i";
export var notificationDot = "_39-q";
export var optionsContainer = "_39-h";
export var primaryNav = "_39-0";
export var primaryNavDivider = "_39-u";
export var primaryNavResizeHandle = "_39-2";
export var primaryNavResizing = "_39-1";
export var primaryNavTabSection = "_39-t";
export var primaryTab = "_39-o";
export var primaryTabIconBox = "_39-r";
export var secondaryNav = "_39-3";
export var selected = "_39-s";
export var settingsNav = "_39-4";
export var settingsNavItems = "_39-5";
export var show = "_39-d";
export var sideNav = "_39-k";
export var teamItem = "_39-a";
export var userProfileItem = "_39-b";